import { extractCollection } from '@/utils/dataNormalization';

export const fetchSalesMultiCustomerRows = async (salesService, params = {}) => {
  const response = await salesService.index(params);
  const rows = extractCollection(response);
  return Array.isArray(rows) ? rows : [];
};
